"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var NODE_TYPE = require("../node-type");

var _require = require("../helpers/strings"),
    stripAndCollapseASCIIWhitespace = _require.stripAndCollapseASCIIWhitespace;

var _require2 = require("../helpers/internal-constants"),
    domSymbolTree = _require2.domSymbolTree;

var _require3 = require("../helpers/namespaces"),
    HTML_NS = _require3.HTML_NS,
    SVG_NS = _require3.SVG_NS;

var _require4 = require("../helpers/traversal"),
    closest = _require4.closest;

var _require5 = require("../helpers/form-controls"),
    formOwner = _require5.formOwner;

var HTMLOptionElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLOptionElementImpl, _HTMLElementImpl);

  function HTMLOptionElementImpl(globalObject, args, privateData) {
    var _this;

    _classCallCheck(this, HTMLOptionElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLOptionElementImpl).call(this, globalObject, args, privateData)); // whenever selectedness is set to true, make sure all
    // other options set selectedness to false

    _this._selectedness = false;
    _this._dirtyness = false;
    return _this;
  }

  _createClass(HTMLOptionElementImpl, [{
    key: "_removeOtherSelectedness",
    value: function _removeOtherSelectedness() {
      // Remove the selectedness flag from all other options in this select
      var select = this._selectNode;

      if (select && !select.hasAttributeNS(null, "multiple")) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = select.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var option = _step.value;

            if (option !== this) {
              option._selectedness = false;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }, {
    key: "_askForAReset",
    value: function _askForAReset() {
      var select = this._selectNode;

      if (select) {
        select._askedForAReset();
      }
    }
  }, {
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      if (!this._dirtyness && name === "selected") {
        this._selectedness = this.hasAttributeNS(null, "selected");

        if (this._selectedness) {
          this._removeOtherSelectedness();
        }

        this._askForAReset();
      }

      _get(_getPrototypeOf(HTMLOptionElementImpl.prototype), "_attrModified", this).call(this, name, value, oldValue);
    }
  }, {
    key: "_getValue",
    // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-value
    value: function _getValue() {
      if (this.hasAttributeNS(null, "value")) {
        return this.getAttributeNS(null, "value");
      }

      return this.text;
    }
  }, {
    key: "_selectNode",
    get: function get() {
      var select = domSymbolTree.parent(this);

      if (!select) {
        return null;
      }

      if (select.nodeName.toUpperCase() !== "SELECT") {
        select = domSymbolTree.parent(select);

        if (!select || select.nodeName.toUpperCase() !== "SELECT") {
          return null;
        }
      }

      return select;
    }
  }, {
    key: "form",
    get: function get() {
      return formOwner(this);
    }
  }, {
    key: "text",
    get: function get() {
      return stripAndCollapseASCIIWhitespace(childTextContentExcludingDescendantsOfScript(this));
    },
    set: function set(value) {
      this.textContent = value;
    }
  }, {
    key: "value",
    get: function get() {
      return this._getValue();
    },
    set: function set(value) {
      this.setAttributeNS(null, "value", value);
    }
  }, {
    key: "index",
    get: function get() {
      var select = closest(this, "select");

      if (select === null) {
        return 0;
      }

      return select.options.indexOf(this);
    }
  }, {
    key: "selected",
    get: function get() {
      return this._selectedness;
    },
    set: function set(s) {
      this._dirtyness = true;
      this._selectedness = Boolean(s);

      if (this._selectedness) {
        this._removeOtherSelectedness();
      }

      this._askForAReset();

      this._modified();
    }
  }, {
    key: "label",
    get: function get() {
      if (this.hasAttributeNS(null, "label")) {
        return this.getAttributeNS(null, "label");
      }

      return this.text;
    },
    set: function set(value) {
      this.setAttributeNS(null, "label", value);
    }
  }]);

  return HTMLOptionElementImpl;
}(HTMLElementImpl);

function childTextContentExcludingDescendantsOfScript(root) {
  var text = "";
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = domSymbolTree.childrenIterator(root)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var child = _step2.value;

      if (child._localName === "script" && (child._namespaceURI === HTML_NS || child._namespaceURI === SVG_NS)) {
        continue;
      }

      if (child.nodeType === NODE_TYPE.TEXT_NODE || child.nodeType === NODE_TYPE.CDATA_SECTION_NODE) {
        text += child.nodeValue;
      } else {
        text += childTextContentExcludingDescendantsOfScript(child);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return text;
}

module.exports = {
  implementation: HTMLOptionElementImpl
};